export default class LoadVideoTexture {
    constructor(src){
        this.video;
        this.videoTexture;
        this.src = src;
    }
    init(){

        this.video = document.createElement('video');
        this.video.preload = 'none';
        this.video.autoplay = false;
        this.video.loop = true;


        this.videoTexture = new THREE.VideoTexture( this.video );
        this.videoTexture.minFilter = THREE.LinearFilter;
        this.videoTexture.magFilter = THREE.LinearFilter;
        this.videoTexture.format = THREE.RGBFormat;
        this.videoTexture.needsUpdate = true;

        this.video.src = this.src;
        this.video.load();
        this.video.muted = true;
        // this.video.play();

        return [this.video,this.videoTexture];

    }

}